module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Now you can read reports from lunches you\u0027ve had!":"Now you can read reports from lunches you\u0027ve had!"},"ja":{"Now you can read reports from lunches you\u0027ve had!":"参加したGIPランチのレポートを確認できるようになりました！"}}')
  delete Component.options._Ctor
}
